export default {
  cancelUnpaidCheckout: "Annuleren",
  changeSelection: "Mijn keuze wijzigen",
  packIncludesBoost:
    "Inclusief de boost van {{count}} dagen, die je advertentie bovenaan haar categorie zet.",
  cartHeading: "Controleer je diensten",
  cartLead: "Alle getoonde diensten worden in één keer afgerekend.",
  existingPayment:
    "Er staat nog een betaling open. Controleer de oorspronkelijke items voordat je opnieuw betaalt.",
  resumePackagePayment: "Openstaande betaling bekijken",
  emptyCart: "Geen diensten geselecteerd.",
  removeItem: "Verwijderen",
  currentCart: "Huidige selectie",
  reviewCartChanged:
    "De selectie is gewijzigd. Controleer de items en accepteer de voorwaarden opnieuw.",
  quoteExpiredCart:
    "Deze promotieofferte is verlopen. Kies de promotie opnieuw bij je advertentie.",
  chooseAgain: "Opnieuw kiezen",
  contextCreateAd: "Prijs voor een nieuwe advertentie",
  contextMyAds: "Prijs via Mijn advertenties",
  paymentOriginal: "Oorspronkelijke betaling",
  viewCart: "Geselecteerde diensten bekijken",

  continueToCart: "Verder naar gezamenlijk afrekenen",
  bankRateNote:
    "Je betaalt in euro’s. Je bank rekent om tegen haar eigen wisselkoers.",
  reverseVat: "Btw verlegd · eenmalige betaling",
  checkout: "Doorgaan naar betalen",
  resumePayment: "Betaling hervatten",
  storeReceipt: "Bekijk de winkelbon",
  title: "Geef je advertentie extra aandacht",
  lead: "Kies betaalde zichtbaarheid, een opvallende uitstraling, of allebei.",
  boost: "Boost",
  boostDetail: "Roterende gesponsorde plekken in relevante zoekresultaten.",
  highlight: "Highlight",
  highlightDetail:
    "Een subtiel groen kader laat je advertentie opvallen. Geen wijziging in rangschikking.",
  bundle: "Val op",
  bundleDetail: "Boost en Highlight, samen voor zeven dagen.",
  days: "{{count}} dagen",
  preview: "Voorbeeld van je advertentie",
  previewNote: "Een voorbeeld van de uitstraling, geen gegarandeerde positie.",
  choose: "Kies een optie",
  continue: "Promotie bekijken",
  notNow: "Niet nu",
  total: "Totaal",
  vat: "Inclusief btw · eenmalige betaling",
  saving: "Bespaar {{amount}} ten opzichte van losse aankoop",
  terms:
    "De promotie begint zodra je advertentie is goedgekeurd en beschikbaar. Ze pauzeert bij onbeschikbaarheid en eindigt bij verkoop of intrekking.",
  consent:
    "Ik accepteer de promotievoorwaarden en verzoek om levering zodra mijn advertentie in aanmerking komt.",
  pay: "Betaal {{amount}}",
  paying: "Bezig…",
  error: "Er ging iets mis. Probeer het opnieuw.",
  retry: "Opnieuw proberen",
  unavailable: "Promoties zijn nu niet beschikbaar voor deze advertentie.",
  history: "Jouw promoties",
  myAdsCta: "Promoties",
  processingPayment: "Betaling wordt verwerkt",
  activeUntil: "Tot {{date}}",
  endedOn: "Afgelopen op {{date}}",
  report: "Campagneresultaten",
  impressions: "Zichtbare vertoningen",
  clicks: "Klikken",
  ctr: "Klikpercentage",
  noData: "Nog geen rapportagegegevens",
  metricsNote:
    "Geregistreerde campagnegebeurtenissen, geen unieke personen of extra verkopen. Een vertoning vereist minimaal de helft van de kaart gedurende één seconde in beeld.",
  updated: "Bijgewerkt op {{date}}",
  start: "Begonnen",
  end: "Eindigt",
  withdraw: "Promotie intrekken",
  withdrawConfirm: "Deze promotie stoppen?",
  withdrawNote:
    "De levering stopt direct. Een eventuele terugbetaling wordt apart beoordeeld; dit is geen belofte van terugbetaling.",
  cancel: "Promotie behouden",
  confirm: "Stoppen en beoordeling aanvragen",
  back: "Terug naar Mijn advertenties",
  sponsored: "Gesponsord",
  advertiser: "Betaald door {{name}}",
  reason: "Waarom deze advertentie?",
  processing:
    "We controleren je betaling bij de server. Sluiten annuleert een afgeronde betaling niet.",
  refresh: "Status vernieuwen",
  paymentConfirmed: "Betaling bevestigd",
  awaiting_payment: "Wacht op betaling",
  awaiting_listing: "Wacht op je advertentie",
  active: "Actief",
  paused: "Gepauzeerd",
  completed: "Afgelopen",
  cancelled: "Geannuleerd",
  refund_required: "Beoordeling nodig",
  refunded: "Terugbetaald",
  refund_requested: "Terugbetaling aangevraagd",
  pending: "In behandeling",
  paid: "Betaald",
  failed: "Mislukt",
  payment: "Betaling",
  noCampaign: "Nog geen campagnes. Je eerste promotie verschijnt hier.",
  viewCampaign: "Campagne bekijken",
  checking: "Beschikbaarheid controleren…",
  expired: "Deze prijsopgave is verlopen. Vernieuw deze voordat je betaalt.",
  noGuarantee: "Geen garantie op positie, vertoningen of verkoop.",
  previewFixture:
    "Lokaal voorbeeld · fictieve advertentie en voorbeeldgegevens · geen aankoop",
  daily: "Dagelijkse activiteit (UTC)",
  date: "Datum",
  selected: "Geselecteerd",
  viewTerms: "Lees de voorwaarden",
  termsTitle: "Promotievoorwaarden",
  termsBody:
    "Dit is een eenmalige betaalde advertentieservice. Gesponsorde plekken roteren tussen relevante advertenties; Highlight wijzigt alleen de uitstraling. De looptijd telt alleen tijdens geschiktheid. Intrekking stopt levering en start een menselijke beoordeling van terugbetaling. Je wettelijke rechten blijven gelden.",
  entryTitle: "Help de juiste kopers jouw item te vinden",
  entryBody:
    "Kies hoe je advertentie opvalt, in zoekresultaten en op de homepage.",
  entryCta: "Bekijk de promotiemogelijkheden",
  editorTitle: "Promoot je advertentie",
  stepChoose: "Kiezen",
  stepReview: "Controleren",
  stepPayment: "Betalen",
  boostBenefit: "Word ontdekt",
  highlightBenefit: "Val op",
  bundleBenefit: "Combineer beide",
  boostBody: "Gesponsorde plekken in relevante zoekresultaten.",
  highlightBody:
    "Laat je advertentie opvallen met een groen kader in zoek- en categorieresultaten.",
  bundleBody:
    "Gesponsorde zichtbaarheid en een groen kader, samen voor zeven dagen.",
  chooseDuration: "Kies je looptijd",
  previewOriginal: "Jouw advertentie",
  previewPromoted: "Met jouw promotie",
  selectionHint: "Kies een optie om verder te gaan",
  reviewTitle: "Jouw promotie in één oogopslag",
  startsWhenReady: "Begint zodra je advertentie is goedgekeurd en beschikbaar",
  pausesWhenNeeded:
    "Pauzeert zolang je advertentie tijdelijk niet beschikbaar is",
  trackResults: "Volg vertoningen en klikken in Mijn advertenties",
  close: "Sluiten",
  changeOption: "Optie wijzigen",
  fromPrice: "Vanaf {{amount}}",
  placementPreview: "Gesponsorde resultaten",
  appearancePreview: "Zoekresultaten",
  previewEmpty: "Bekijk hoe je advertentie eruit kan zien",
  oneTime: "Eenmalige betaling",
  reportListing: "Jouw advertentie",
  viewListing: "Advertentie bekijken",
  reportActivity: "Promotieactiviteit",
  reportAllTime: "Over de hele promotie",
  reportShown: "Aantal vertoningen",
  reportShownHelp: "Je gepromote advertentie was zichtbaar op het scherm.",
  reportClicksHelp: "Klikken op je gepromote advertentie.",
  reportRateHelp: "Klikken gedeeld door geregistreerde vertoningen.",
  reportChecked: "Rapport gecontroleerd op {{date}}",
  reportDaily: "Activiteit per dag",
  reportPeriod: "Rapportageperiode",
  reportFullPeriod: "Hele periode",
  reportLastDays: "Laatste {{count}} dagen met activiteit",
  reportRecordedDays:
    "Alleen datums met geregistreerde activiteit worden getoond. Dagen worden ingedeeld volgens UTC.",
  reportDataTable: "Dagcijfers bekijken",
  reportNoActivity: "Geen activiteit geregistreerd",
  reportNoActivityBody:
    "Geregistreerde vertoningen en klikken verschijnen hier. De totalen hierboven tonen wat tot nu toe is gemeten.",
  reportBeforeStart: "Je rapport begint zodra de promotie start.",
  reportPurchase: "Jouw promotie",
  reportIncluded: "Inbegrepen in deze promotie",
  reportAmount: "Aankoopbedrag",
  reportPurchased: "Betaling ontvangen",
  reportReference: "Campagnereferentie",
  reportScheduledEnd: "Geplande einddatum",
  reportFinishedOn: "Afgelopen",
  reportSupport: "Contact opnemen",
  reportRefreshWarning:
    "We konden dit rapport niet vernieuwen. Je laatst beschikbare informatie blijft zichtbaar.",
  reportPollingStopped:
    "We wachten nog op een betalingsupdate. Automatische controles zijn gepauzeerd; vernieuw de status om opnieuw te controleren.",
  reportResumeBody:
    "Ga verder met je bestaande betaling. Heb je al betaald? Vernieuw dan de status voordat je het opnieuw probeert.",
  reportPendingBody:
    "De betaling is nog niet bevestigd. Controleer de oorspronkelijke betaling of de appstore; je hoeft geen nieuwe promotie te kopen.",
  reportActiveTitle: "Je promotie loopt",
  reportActiveBody:
    "De gekozen voordelen zijn actief zolang je advertentie beschikbaar is voor kopers.",
  reportWaitingTitle: "Klaar zodra je advertentie dat is",
  reportWaitingBody:
    "Je betaling is bevestigd. De promotie start zodra je advertentie is goedgekeurd en beschikbaar. Je betaalde looptijd is nog niet begonnen.",
  reportPausedTitle: "Je promotie is gepauzeerd",
  reportPausedBody:
    "Je advertentie is tijdelijk niet beschikbaar. De promotie wordt hervat zodra dat weer zo is. De gepauzeerde tijd wordt toegevoegd aan je looptijd.",
  reportHolidayBody:
    "Je promotie is gepauzeerd terwijl je winkel op vakantie is. Je betaalde tijd blijft behouden totdat je advertentie weer beschikbaar is.",
  reportReservedBody:
    "Je advertentie is gereserveerd. De promotie pauzeert zolang de reservering geldt; je betaalde tijd blijft behouden.",
  reportVerificationBody:
    "We controleren je aankoop in de appstore. De promotie is gepauzeerd en je betaalde tijd blijft behouden. Je hoeft niet opnieuw te kopen.",
  reportPlatformPauseBody:
    "We hebben promoties tijdelijk gepauzeerd. Je betaalde tijd blijft behouden; je hoeft niets te doen.",
  reportApprovalBody:
    "Je advertentie wordt beoordeeld. De promotie start of hervat zodra deze is goedgekeurd en beschikbaar. Wachttijd gaat niet van je looptijd af.",
  reportFinishedTitle: "Je promotie is afgelopen",
  reportFinishedBody:
    "Je gekochte looptijd is verstreken. Het rapport hieronder toont de geregistreerde activiteit tijdens je promotie.",
  reportSoldBody:
    "Je item is verkocht, daarom is de promotie beëindigd. De activiteit hieronder toont wat is geregistreerd, niet dat de promotie tot de verkoop heeft geleid.",
  reportWithdrawnBody:
    "Je advertentie is niet meer beschikbaar, daarom is de promotie gestopt.",
  reportStoppedTitle: "Je promotie is gestopt",
  reportStoppedBody:
    "Deze promotie is niet meer actief. Je geregistreerde activiteit en aankoopgegevens blijven hieronder beschikbaar.",
  reportReviewTitle: "Je promotie moet worden beoordeeld",
  reportReviewBody:
    "De promotie is gestopt terwijl we deze aankoop beoordelen. Neem contact op als je hulp nodig hebt; er is geen terugbetaling bevestigd.",
  reportWithdrawalBody:
    "Je verzoek is ontvangen en de promotie is gestopt. Een eventuele terugbetaling wordt apart beoordeeld.",
  reportRefundedTitle: "Betaling terugbetaald",
  reportRefundedBody:
    "Een terugbetaling is bevestigd en deze promotie is niet meer actief.",
  reportNotFound: "We konden deze promotie niet vinden in je account.",
  reportWithdrawalFailed:
    "We konden je verzoek niet bevestigen. Dit venster blijft open zodat je het opnieuw kunt proberen. Controleer bij twijfel de campagnestatus.",
  reportRequestReview: "Beoordeling aanvragen",
  reportReviewConfirm: "Een beoordeling van deze promotie aanvragen?",
  reportReviewNote:
    "De promotie is al beëindigd. We beoordelen je verzoek apart; dit is geen belofte van terugbetaling.",
  reportConfirmReview: "Verzoek versturen",
  reportEndedNoActivity:
    "Er is geen activiteit geregistreerd voordat deze promotie stopte.",
  customPromotion: "Jouw promotie",
  border: "Kader",
  label: "Label",
  homepage: "Homepageplek",
  fullBundle: "Opvalpakket",
  selectBundle: "Kies Stand out",
  bundleIncludes: "Boost, Kader en Label voor 7 dagen",
  bundleSaving: "Bespaar {{amount}} vergeleken met losse aankopen",
  bundleRecommendation:
    "Krijg 7 dagen Boost, Kader en Label voor {{amount}} — goedkoper dan deze selectie.",
  borderBody: "Een groen kader om je kaart.",
  labelBody: "Een door jou gekozen verkoperslabel.",
  homepageBody: "Roulerende gesponsorde homepagekaarten.",
  homepageTerms:
    "Een wisselende plek, geen exclusieve positie. Geen gegarandeerde vertoningen of verkoop.",
  homepageHeading: "Ontdek meer",
  homepageContext: "Op de homepage",
  homepagePreviewNote:
    "Je kaart komt in een wisselende gesponsorde selectie. Deze preview belooft geen vaste positie.",
  labelChoose: "Kies een label",
  labelMustGo: "Moet nu weg",
  labelMovingSale: "Verhuisverkoop",
  labelInvoice: "Met originele factuur",
  labelCollect: "Klaar om op te halen",
  labelAttestation: "Ik bevestig dat dit label klopt voor mijn advertentie.",
  labelPaidNote:
    "Gekozen en betaald door de verkoper. Dit is geen verificatie door Whoppah.",
  labelRequired:
    "Kies een label en bevestig dat het klopt voordat je verdergaat.",
  none: "Geen",
  addBenefit: "{{benefit}} toevoegen",
  removeBenefit: "{{benefit}} verwijderen",
  selectionUnavailable:
    "Deze selectie is momenteel niet beschikbaar. Pas je keuzes aan of controleer de beschikbaarheid opnieuw.",
  effectUnavailable: "Al actief of niet beschikbaar voor deze advertentie",
  homepageSoldOut:
    "De homepageplekken zijn momenteel vol. Kies andere voordelen of probeer het later opnieuw.",
  checkAvailability: "Beschikbaarheid controleren",
  mixedDurationNote:
    "Elk voordeel heeft zijn eigen looptijd. De homepageplek eindigt na 3 dagen; langere voordelen lopen door.",
  selectedBenefits: "Jouw gekozen voordelen",
  benefitStatus: "Status per voordeel",
  placementsTitle: "Waar je promotie verscheen",
  placementSearch: "Zoekresultaten",
  placementCategory: "Categorieresultaten",
  placementCard: "Kader en label op kaarten",
  placementHomepage: "Homepage",
  placementLegacyHighlight: "Gemarkeerde kaarten",
  placementOther: "Andere plek",
  sharedExposureNote:
    "Eén kaart kan voordelen van meerdere aankopen tonen. Campagnetotalen tellen geregistreerde vertoningen, geen uniek bereik.",
  homepageCapacityWait:
    "Je betaling is bevestigd. De promotie begint zodra een homepageplek en je advertentie beschikbaar zijn. Je betaalde looptijd is nog niet begonnen.",
  labelSuppressed:
    "Dit label is gestopt voor beoordeling. Neem contact op voor hulp bij je aankoop.",
  newBenefits: "Andere promotievoordelen toevoegen",
  previewSearch: "Kaart in zoek- en categorieresultaten",
  previewHome: "Homepagekaart",
  benefitEnd: "Gepland einde van dit voordeel",
  benefitStarts: "Voordeel gestart",
  historicalBundle: "Boost en Highlight",
  bundleV2Body:
    "Boost, een groen kader en je gekozen label, samen voor 7 dagen.",
  customPromotionBody: "Jouw gekozen promotievoordelen.",
  customPromotionBenefit: "Kies je voordelen",
  placementPartial:
    "Voor een deel van de geregistreerde activiteit ontbreken plaatsingsdetails. Die activiteit telt wel mee in je campagnetotalen.",
  reportSomeActiveBody:
    "Er loopt minstens één voordeel. Bekijk hieronder de eigen status en datums van elk voordeel.",
  homepageWaitReview:
    "Er kwam binnen de wachttijd geen homepageplek vrij. Deze aankoop moet op terugbetaling worden beoordeeld; er is nog geen terugbetaling bevestigd.",
  chooseBenefits: "Stel je promotie samen",
  selectionBenefitsHint: "Kies één of meer opties",
  termsBodyV2:
    "Dit is een eenmalige betaalde advertentiedienst. Plaatsen op de homepage rouleren. Kader en Label veranderen het uiterlijk van de kaart; labels worden gekozen en bevestigd door de verkoper, niet gecontroleerd door Whoppah. Elke optie loopt voor de gekochte duur zolang de advertentie in aanmerking komt. Een aankoop met een homepageplek begint wanneer zowel een plek als de advertentie beschikbaar is. Intrekken stopt de vertoning en start een persoonlijke beoordeling van de terugbetaling. Je wettelijke rechten blijven gelden.",
  homepageStartFact:
    "Begint zodra je advertentie en een homepageplek beschikbaar zijn",
  salesEyebrow: "LAAT HET OPVALLEN",
  salesTitle: "Goed design verdient het om gezien te worden.",
  salesBody: "Kies een pakket of stel zelf samen.",
  offerBoostBody: "Bereik kopers die zoeken naar items zoals dat van jou.",
  offerBundleBody:
    "Extra zichtbaarheid. Een opvallende uitstraling. Alles in één pakket.",
  offerHomeTitle: "Stand out + homepage",
  offerHomeBody: "Val op in zoekresultaten en trek de aandacht op de homepage.",
  offerBoostCta: "Kies Boost",
  offerHomeCta: "Kies pakket",
  offerAllTogether: "Zichtbaarheid + stijl",
  offerWiderReach: "Zoekresultaten + homepage",
  offerSearchReach: "Zichtbaarheid in zoekresultaten",
  offerRecommended: "Onze keuze",
  offerMixedDuration: "Stand out 7 dagen · Homepage 3 dagen",
  offerSearchBenefit: "Gesponsorde plekken in relevante zoekresultaten",
  offerStyleBenefit: "Groen kader + verkoperslabel",
  offerResultsBenefit: "Volg vertoningen en klikken in Mijn advertenties",
  offerBundleBenefit: "Boost + Kader + Label",
  offerHomeBenefit: "Roulerende homepageplek",
  offerSelected: "Geselecteerd",
  offerCustomize: "Kies losse opties",
  offerMakeYours: "Jouw voorbeeld",
  offerPreviewBody: "Controleer je keuze voordat je betaalt.",
  completionOptional:
    "Promotie is optioneel. Je kunt ook later kiezen in Mijn advertenties.",
  individualOptionsBody: "Kies één optie of combineer.",
  individualLink: "Bekijk losse opties",
  standOutTitle: "Laat je advertentie opvallen",
  standOutLead:
    "Kies er een of meer. Start zodra je advertentie live en beschikbaar is.",
  packDetail: "Boost van 7 dagen, kader en label samen.",
  bestValue: "Voordeligst",
  percentOff: "{{percent}}% korting",
  orSeparately: "of kies los",
  boostPickerDetail:
    "Je advertentie komt weer bovenaan in haar categorie. Start zodra je advertentie live staat.",
  boostRunning:
    "Deze advertentie heeft al een lopende boost. Je kunt een nieuwe boost toevoegen zodra die is afgelopen.",
  framePickerDetail:
    "Een groen kader om je advertentie in de zoekresultaten, 7 dagen lang.",
  labelMustGoTitle: "'Moet nu weg'-label",
  previousPaymentProcessing:
    "Je vorige betaling wordt nog verwerkt. Probeer het over een minuut opnieuw.",
  labelPickerDetail: "Een kort label op je advertentie, 7 dagen lang.",
  homepagePickerDetail:
    "Een roterende gesponsorde plek op de homepage, 3 dagen lang.",
  searchPreviewTitle: "Zo ziet je advertentie eruit in de zoekresultaten",
  searchPreviewLead:
    "Jouw advertentie, met grijze vakken voor de advertenties eromheen.",
  promotedTab: "Gepromoot",
  boostSummary: "Boost van {{count}} dagen",
  labelSummary: "Label “{{text}}”",
  nothingSelected: "Niets gekozen",
  continueWithPrice: "Door naar betalen · {{price}}",
  goToMyAds: "Naar Mijn advertenties",
  pricingContextChanged:
    "De korting voor een nieuwe advertentie is niet meer beschikbaar. De prijzen zijn vernieuwd.",
} as const;
